///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createReducer, on } from '@ngrx/store';
import { getSystemInfo, setSystemInfo } from './system-info.actions';
import { initialState, SystemInfoState } from './system-info.state';

export const reducer = createReducer(
    initialState,

    on(getSystemInfo, (state: SystemInfoState): SystemInfoState => {
        return {
            ...state,
            isLoading: true
        };
    }),

    on(setSystemInfo, (state: SystemInfoState, action): SystemInfoState => {
        return {
            ...state,
            info: action.systemInfo,
            isLoading: false
        };
    })
);
